import { paymentMethodStatusValue } from "@redotech/redo-billing-common/payment-method-status";
import * as z from "zod";

const PaymentMethodSummarySchema = z.object({
  type: z.string(),
  last4: z.string().nullable(),
  brand: z.string().nullable(),
  expMonth: z.number().nullable(),
  expYear: z.number().nullable(),
  status: paymentMethodStatusValue,
});

export type PaymentMethodSummary = z.infer<typeof PaymentMethodSummarySchema>;

export const getBillingStatus = {
  name: "getBillingStatus" as const,
  input: z.object({}),
  output: z.object({
    hasStripeCustomer: z.boolean(),
    hasPaymentMethod: z.boolean(),
    paymentMethodSummary: PaymentMethodSummarySchema.nullable(),
    /** Set only while micro-deposit verification can still be completed. */
    pendingVerificationClientSecret: z.string().nullable(),
  }),
};

export const createBillingSetupIntent = {
  name: "createBillingSetupIntent" as const,
  input: z.object({
    country: z.string().optional(),
    /** ISO 4217 billing currency; selects that currency's Stripe account. */
    currency: z.string().length(3).optional(),
  }),
  output: z.object({
    clientSecret: z.string(),
    bankPaymentMethod: z.string().nullable(),
    publishableKey: z.string().optional(),
  }),
};

export const saveBillingPaymentMethod = {
  name: "saveBillingPaymentMethod" as const,
  input: z.object({
    paymentMethodId: z.string(),
    setupIntentClientSecret: z.string().nullish(),
    currency: z.string().length(3).optional(),
  }),
  output: PaymentMethodSummarySchema.extend({
    pendingVerificationClientSecret: z.string().nullable(),
  }),
};
